"use client";

/**
 * Small account button + DarkMenu for sign-out.
 * - Renders a circular button with provided initials.
 * - Reuses DarkMenu styling for a single "Sign out" action.
 */
import { useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { useUser } from "@clerk/nextjs";
import DarkMenu from "@/components/molecules/ui/DarkMenu";

import Image from "next/image";

export default function AccountMenu({
  initials,
  avatarUrl,
}: {
  initials: string;
  avatarUrl?: string | null;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLButtonElement | null>(null);
  const router = useRouter();
  const { user } = useUser();
  const email = user?.primaryEmailAddress?.emailAddress;

  return (
    <div className="relative z-canvas-controls">
      <button
        ref={ref}
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="h-10 w-10 overflow-hidden rounded-full bg-[#C084FC] text-white text-sm font-semibold shadow-md ring-2 ring-white/70"
        aria-haspopup="menu"
        aria-expanded={open}
        title="Account"
      >
        {avatarUrl ? (
          // eslint-disable-next-line @next/next/no-img-element -- remote Clerk avatar host, not configured for next/image
          <img src={avatarUrl} alt="Avatar" className="h-full w-full object-cover" />
        ) : (
          initials
        )}
      </button>
      <DarkMenu
        items={[
          ...(email ? [{ id: "email", label: `Signed in as ${email}`, disabled: true }] : []),
          { id: "signout", label: "Sign out" },
        ]}
        open={open}
        onOpenChange={setOpen}
        onSelect={(id) => {
          if (id === "signout") router.push("/sign-out");
        }}
        anchorRef={ref}
        align="end"
        minWidth={220}
        placement="bottom-end"
      />
    </div>
  );
}
